import { connect } from 'react-redux';
import { CustomHeader } from './component';
import { mapStateToProps } from './redux';


export default connect(mapStateToProps)(CustomHeader);
